<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="!!backButtonRoute"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedTabIndex"
    ref="gc-base-layout"
    class="bill-of-materials"
  >
    <slot></slot>

    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Bill of Materials'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Bill of Materials # ' + formModel.BillNo"
        :secondaryLabel="undefined"
        v-if="loaded"
      />
    </template>

    <div class="split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <dx-data-grid
              :height="getGridHeight"
              :columns="getGridColumns"
              :data-source="getDataSource"
              @toolbar-preparing="onToolbarPreparing($event)"
              @content-ready="onContentReady"
              ref="data-grid"
              :columnChooser="{
                enabled: false,
              }"
              @row-click="onRowClick"
            >
              <DxPaging :page-size="200" :enabled="false" />

              <DxPager :visible="false" />

              <template #RecordTemplate="{ data }">
                <GcRecordCell
                  :data="data"
                  :primary="[
                    {
                      dataField: 'ProcessDescription',
                    },
                  ]"
                  :secondary="[
                    {
                      dataField: 'ProcessCode',
                    },
                  ]"
                />
              </template>
              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preload-enabled="true"
              />
            </dx-data-grid>
          </div>
        </template>

        <template #rightContent>
          <gc-form-header-toolbar
            :toolbar-options="getHeaderToolbar"
            :data-model="formModel"
            :backRoute="getFormBackURL"
            :formLocation="'Left'"
            v-if="loaded"
            :itemSaveCallBack="itemSaveCallBack"
            :baseView="baseView"
          ></gc-form-header-toolbar>

          <div class="view-card responsive-paddings split-view-form">
            <GcForm
              :formOptions="formOptions"
              :formItems="getFormItems"
              :isNormal="true"
              :data-model="formModel"
              v-if="loaded"
              :formMode="baseView.mode"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'split-view-form'"
              :formLocation="'normal'"
              :formContentReady="formContentReady"
              :formHeight="getFormHeight"
              ref="split-view-form"
            />
          </div>
        </template>
      </gc-split-view>
    </div>
  </GcBaseLayout>
</template>

<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import FormMixin from "@/_mixins/form.mixin";
import RouteMixin from "@/_mixins/route.mixin";

import {
  BillOfMaterialsTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/production/bill-of-materials-tabs";
import { mapGetters } from "vuex";
import { BillOfMaterialsService } from "../../../_services/api/production/bill-of-materials.service";
import { FeatureStorage } from "../../../_services/storage";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";
export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      formModel: {
        BillNo: "",
        ProcessCode: "",
        AssemblyCode: "",
        IsFixedAssembly: false,
        IssueToParent: false,
        Margin: 0.0,
        Quantity: 1.0,
        LeadDays: 0,
        Comment: "",

        DateChanged: null,
        DateCreated: null,
        CreatedBy: null,
        ChangedBy: null,
      },
      formOptions: {
        gcLabelLocation: "left",
      },
      formHeight: "auto",
      isValid: false,
      AddedProductsList: [],
    };
  },
  async created() {
    if (this.baseView.mode === "create") {
      this.formModel.BillNo = this.baseView.id;
    } else {
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        await this.getBomAssemblyByRecordId();
      } else {
        this.formModel.BillNo = JSON.parse(JSON.stringify(this.baseView.id));
      }
    }
    this.$nextTick(() => {
      this.loaded = true;

      this.focusOnForm();
    });
  },
  async mounted() {},
  beforeDestroy() {},

  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    getGridHeight() {
      return this.gridHeight - 20;
    },
    setBaseView() {
      let baseView = { ...this.baseView };
      baseView.id = this.formModel.BillNo;

      return baseView;
    },
    showLeftContainer() {
      return true;
    },

    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    backButtonRoute() {
      return "/bill-of-materials";
    },
    getTabs() {
      return BillOfMaterialsTabs(this.setBaseView);
    },
    selectedTabIndex() {
      return GetIndexByTabName("Assembly", this.setBaseView);
    },

    getGridColumns() {
      return [
        {
          caption: "Process",
          dataField: "ProcessCode",
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth + 50,
          cellTemplate: "RecordTemplate",
        },
        {
          caption: "Assembly",
          dataField: "AssemblyCode",
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth + 50,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.AssemblyDescription}
                        </span>
                      <span class="record-secondary gc-grid-code">
                        ${info.data.AssemblyCode}
                      </span>
                    </div>`);
          },
        },
        {
          caption: "Margin (%)",
          dataField: "Margin",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.00",
        },
        {
          caption: "Quantity",
          dataField: "Qty",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          screenField: "Comments",
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          filterIndex: 4,
          dataType: "string",
          type: "Text",
          textOperators: true,
          dataField: "Comment",
        },
      ];
    },
    getDataSource() {
      return BillOfMaterialsService.dataSourceConfig("api/BomAssemblyList", {
        filter: [["BomCode", "=", this.formModel.BillNo]],
      });
    },

    // From Related
    getFormBackURL() {
      return "/bill-of-materials-assembly/" + this.formModel.BillNo;
    },
    getHeaderToolbar() {
      return {
        closeSplit: true,
        save: this.isUserEntryAllowed,
        audit: true,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
            ],
          },
        ],
        toolbarFormLocation: "after",
        editURL: "/bill-of-materials-assembly",
        editCallBack: this.editCallBack,
        delete:
          this.baseView.mode !== "create" && this.isUserEntryAllowed
            ? true
            : false,
        deleteCallBack: this.deleteCallBack,
      };
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "ProcessCode",
              label: { text: "Process", location: "left" },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource:
                  this.baseView.mode !== "create"
                    ? this.getProcessCodeSource([])
                    : [],
                onFocusIn: async (e) => {
                  if (!e.event) return;
                  const items = this.$refs["data-grid"].instance
                    .getDataSource()
                    .items();
                  const selectBox = e.component;
                  selectBox.option(
                    "dataSource",
                    this.getProcessCodeSource(items)
                  );
                  await this.$nextTick();
                  setTimeout(() => {
                    selectBox.focus();
                    this.$nextTick(() => {
                      e.event.target.select();
                    });
                  }, 200);
                },
                valueExpr: "ProcessCode",
                displayExpr: (item) => {
                  if (item)
                    return item.ProcessCode + " - " + item.ProcessDescription;
                  else return "";
                },
                searchExpr: ["ProcessCode", "ProcessDescription"],
                searchEnabled: true,
                showClearButton: true,
                placeholder: "Select Process",
                onValueChanged: (e) => {
                  if (e.event && e.value) {
                    this.$nextTick(() => {
                      this.onProcessCodeChange(e);
                    });
                  }
                },
                tabIndex: 1,
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.ProcessCode}" >
                            <span class="auto-complete-primary">
                              ${data.ProcessCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.ProcessDescription}
                            </span>
                          </div>`;
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Process is required",
                },
              ],
            },
            {
              dataField: "AssemblyCode",
              label: { text: "Assembly", location: "left" },
              editorType: "dxSelectBox",
              editorOptions: {
                tabIndex: 2,
                dataSource: this.getAsseemblyDataSource,
                valueExpr: "BomCode",
                displayExpr: (item) => {
                  if (item) return item.BomCode + " - " + item.BomDescription;
                  else return "";
                },
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.BomCode}" >
                            <span class="auto-complete-primary">
                              ${data.BomCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.BomDescription}
                            </span>
                          </div>`;
                },
                searchEnabled: true,
                showClearButton: true,
                searchExpr: ["BomCode", "BomDescription"],
              },
              validationRules: [
                {
                  type: "required",
                  message: "Assembly is required",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "IsFixedAssembly",
                  label: { text: "Fixed Assembly" },
                  editorType: "dxSwitch",
                  editorOptions: {
                    tabIndex: 3,
                  },
                },
                {
                  dataField: "IssueToParent",
                  label: { text: "Issue to Parent" },
                  editorType: "dxSwitch",
                  editorOptions: {
                    tabIndex: 4,
                  },
                },
              ],
            },
            {
              dataField: "Margin",
              editorType: "dxNumberBox",
              label: { text: "Margin (%)" },
              editorOptions: {
                format: "Decimal-3-2",
                tabIndex: 5,
              },
              validationRules: [
                {
                  type: "range",
                  min: 0.0,
                  message: "Margin (%) must be greater than or equal to 0.0000",
                },
              ],
            },
            {
              dataField: "Quantity",
              label: { text: "Quantity", location: "left" },
              editorType: "dxNumberBox",
              editorOptions: {
                format: "##,###,###,###,##0.0000",
                // onValueChanged: this.onQuantityValueChanged,
                tabIndex: 6,
              },
              required: true,
            },
            {
              label: { text: "Lead Days" },
              dataField: "LeadDays",
              editorType: "dxNumberBox",
              editorOptions: {
                format: "##,###,###,###,##0",
                tabIndex: 7,
              },
            },
            {
              dataField: "Comment",
              label: { text: "Comment", location: "top" },
              editorType: "dxTextArea",
              cssClass: "comment-textarea",
              editorOptions: {
                height: 90,
                maxLength: 1000,
                showClearButton: true,
                tabIndex: 8,
              },
            },
          ],
        },
      ];
    },
    getFormHeight() {
      if (this.formConfig && this.formConfig.formHeight)
        return this.formConfig.formHeight;
      else return "auto";
    },
    getAsseemblyDataSource() {
      return BillOfMaterialsService.dataSourceConfig("api/BomList", {
        filter: this.getAddedProductFilter,
        paginate: true,
      });
    },

    getAddedProductFilter() {
      let filter = [
        ["BomCode", "<>", this.formModel.BillNo],
        "and",
        ["Status", "=", "A"],
      ];
      if (this.AddedProductsList && this.AddedProductsList.length > 0) {
        let addedFilter = [];

        this.AddedProductsList.forEach((product) => {
          if (addedFilter.length > 0) addedFilter.push("and");
          addedFilter.push(["BomCode", "<>", `${product.AssemblyCode}`]);
        });

        if (addedFilter.length > 0) filter.push("and", addedFilter);

        return filter;
      }
      return filter;
    },

    isUserEntryAllowed() {
      return FeatureStorage.checkPermission("BillOfMaterial", "create");
    },
  },
  methods: {
    editCallBack() {
      this.$nextTick(() => {
        this.focusOnForm();
      });
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            visible: this.isUserEntryAllowed,
            onClick: async () => {
              if (this.baseView.mode !== "review") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes"
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewAssembly();
                }
              } else {
                this.createNewAssembly();
              }
            },
            // disabled: true,
          },
        },
        searchPanel
      );
    },

    async createNewAssembly() {
      await this.resetFormToDefault();
      this.$router
        .push({
          path: `/bill-of-materials-assembly/create/${this.formModel.BillNo}`,
        })
        .then(() => {
          this.$nextTick(() => {
            this.focusOnForm();
          });
        });
    },

    resetFormToDefault() {
      this.formModel.ProcessCode = null;
      this.formModel.AssemblyCode = null;
      this.formModel.IsFixedAssembly = false;
      this.formModel.IssueToParent = false;
      this.formModel.Margin = 0.0;
      this.formModel.Quantity = 1.0;
      this.formModel.LeadDays = 0;
      this.formModel.Comment = "";
      this.AddedProductsList = [];

      this.formModel.DateChanged = null;
      this.formModel.DateCreated = null;
      this.formModel.CreatedBy = null;
      this.formModel.ChangedBy = null;
    },

    /**
     * On Content Ready
     * @param e Event
     */
    onContentReady(e) {
      if (e) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Assemblies",
            message:
              "There are no Assemblies linked to this Bill of Materials. Add a new Assembly.",
          },
        });
      }
      this.$nextTick(() => {
        this.reSizeGrid(e.component);
      });
    },

    /**
     * Resize Grid
     * @param component Grid Component
     */
    reSizeGrid(component) {
      component.beginUpdate();
      component.updateDimensions();
      component.endUpdate();
    },

    /**
     * Item Save Call Back
     */
    itemSaveCallBack() {
      this.isValid = true;
    },

    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.SaveBomNewAssembly();
      }

      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    async SaveBomNewAssembly() {
      this.showLoading(true);

      try {
        const response = await BillOfMaterialsService.SaveBomNewAssembly(
          this.getPayload()
        );

        if (response) {
          this.$nextTick(() => {
            this.setIgnoreRouteChangeConfirmation();
            this.$router
              .push({
                path: this.getFormBackURL,
              })
              .then(() => {
                this.$refs["data-grid"].instance.refresh();
              });
          });
        }
      } catch (error) {
        this.displayServerError(
          error,
          "Error saving Process to Bill of Materials"
        );
      } finally {
        this.showLoading(false);
      }
    },

    getPayload() {
      const items = this.$refs["data-grid"].instance.getDataSource().items();
      let BomNewAssemblyDetails = [];

      BomNewAssemblyDetails = items
        .filter((x) => x.RecordId._value !== this.baseView.id)
        .map((x) => ({
          ProcessCode: x.ProcessCode,
          AssemblyCode: x.AssemblyCode,
          IsFixedAssembly: true,
          IssueToParent: "N",
          Margin: x.Margin,
          Qty: x.Qty,
          LeadDays: 5,
          Comment: x.Comment,
          RecordId: x.RecordId,
        }));

      BomNewAssemblyDetails.push({
        ProcessCode: this.formModel.ProcessCode,
        AssemblyCode: this.formModel.AssemblyCode,
        IsFixedAssembly: this.formModel.IsFixedAssembly,
        IssueToParent: this.formModel.IssueToParent ? "Y" : "N",
        Margin: this.formModel.Margin,
        Qty: this.formModel.Quantity,
        LeadDays: this.formModel.LeadDays,
        Comment: this.formModel.Comment,
        RecordId: "00000000-0000-0000-0000-000000000000",
      });

      let payload = {
        BomCode: this.formModel.BillNo,
        BomNewAssemblyDetails: BomNewAssemblyDetails,
      };

      return payload;
    },

    /**
     * Form Content Ready
     * @param e Event
     */
    formContentReady(e) {
      if (e)
        this.formHeight =
          this.heigthForForm -
          document.getElementsByClassName("form-header-toolbar")[0]
            .clientHeight -
          40;
    },

    getProcessCodeSource(items) {
      let filter = [["BomCode", "=", this.formModel.BillNo]];
      let processFilter = [];
      if (items && items.length > 0) {
        items.forEach((element) => {
          if (element.ProcessCode) {
            if (
              this.baseView.mode === "edit" &&
              element.ProcessCode === this.formModel.ProcessCode
            ) {
              return;
            }

            if (processFilter.length > 0) {
              processFilter.push("and");
            }
            processFilter.push(["ProcessCode", "<>", element.ProcessCode]);
          }
        });
      }

      if (processFilter.length > 0) {
        filter.push("and");
        filter.push(processFilter);
      }

      return BillOfMaterialsService.dataSourceConfig("api/BomProcessList", {
        filter: filter,
        sort: "ProcessCode asc",
        select: "ProcessCode,ProcessDescription,BomCode",
        paginate: true,
      });
    },

    /**
     * Focus On Form
     */
    focusOnForm() {
      setTimeout(() => {
        this.$nextTick(() => {
          if (
            this.$refs["split-view-form"] &&
            this.$refs["split-view-form"].$refs["gc-form-comp"]
          ) {
            const formInstance =
              this.$refs["split-view-form"].$refs["gc-form-comp"].instance;
            if (formInstance) {
              const firstElement = formInstance.getEditor("ProcessCode");
              if (firstElement) {
                firstElement.focus();
              }
            }
          }
        });
      }, 150);
    },

    async getAddedBOMForProcess(processCode, billNo) {
      try {
        const response = await BillOfMaterialsService.getAddedBOMForProcess(
          processCode,
          billNo
        );

        if (IsResponseDataValid(response)) {
          this.AddedProductsList = response.data.value;
        } else {
          // this.AddedProductsList = [];
        }
      } catch (error) {
        this.displayServerError(error);
      }
    },

    /**
     * On Process Code Change
     * @param e Event
     */
    onProcessCodeChange(e) {
      if (!e.value) {
        return;
      }
      this.formModel.ProcessCode = JSON.parse(JSON.stringify(e.value));
      setTimeout(() => {
        this.updateFormValues("ProcessCode", this.formModel.ProcessCode);
        this.$nextTick(() => {
          this.getAddedBOMForProcess(e.value, this.formModel.BillNo);
        });
      }, 100);
    },

    /**
     * Update Form Values
     * @param dataField Data Field
     * @param value Value
     */
    updateFormValues(dataField, value) {
      const form = this.$refs["split-view-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },

    /**
     * On Row Click
     * @param e Event
     */
    onRowClick(e) {
      if (e.event) {
        const data = e.data;
        this.$router
          .push({
            name: "bill-of-materials-assembly-review",
            params: { id: data.RecordId },
          })
          .then(() => {
            this.$nextTick(() => {
              this.getBomAssemblyByRecordId();
            });
          });
      }
    },

    /**
     * Get Bom Material By Record Id
     */
    async getBomAssemblyByRecordId() {
      this.showLoading(true);
      try {
        const response = await BillOfMaterialsService.getBomAssemblyByRecordId(
          this.baseView.id
        );

        if (IsResponseDataValid(response)) {
          const data = response.data.value[0];
          this.formModel.BillNo = data.BomCode;
          this.formModel.ProcessCode = data.ProcessCode;
          this.formModel.AssemblyCode = data.AssemblyCode;
          this.formModel.IsFixedAssembly = data.IsFixedAssembly;
          this.formModel.IssueToParent = data.IssueToParent === "Y";
          this.formModel.Margin = data.Margin;
          this.formModel.Quantity = data.Qty;
          this.formModel.LeadDays = data.LeadDays;

          this.formModel.Comment = data.Comment;

          this.formModel.DateChanged = data.DateChanged;
          this.formModel.DateCreated = data.DateCreated;
          this.formModel.ChangedBy = data.ChangedBy;
          this.formModel.CreatedBy = data.CreatedBy;
        }
      } catch (error) {
        this.displayServerError(error);
      } finally {
        this.showLoading(false);
      }
    },

    /**
     * Delete Call Back
     */
    async deleteCallBack() {
      const confirmDelete = await this.$confirm(
        "Are you sure you want to delete this Assembly from Bill of Materials?",
        "Confirm Deletion"
      );

      if (confirmDelete) {
        this.showLoading(true);
        try {
          const response = await BillOfMaterialsService.deleteBomAssembly(
            this.baseView.id
          );

          if (response) {
            this.$nextTick(() => {
              this.setIgnoreRouteChangeConfirmation();
              this.$router
                .push({
                  path: this.getFormBackURL,
                })
                .then(() => {
                  this.$refs["data-grid"].instance.refresh(true);
                });
            });
          }
        } catch (error) {
          this.displayServerError(
            error,
            "Error deleting assembly from Bill of Materials"
          );
        } finally {
          this.showLoading(false);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.bill-of-materials {
  .pack-size {
    padding-right: 0 !important;
  }
  .batch-size {
    padding-left: 10 !important;
    > label {
      // width: 75px !important;
    }
  }
}
</style>
